/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EmptyState } from '@squiz/sds';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COMPONENT_SERVICE_STRINGS } from '../../../../Constants/Strings.constants';
import { EntityComponentVersionSetsItem } from '../../../../Services/component';
import { ComponentDetailsProps } from '../../ComponentDetails.props';
import { ComponentDetailsSetsItem } from './elements/ComponentDetailsSetsItem';

/**
 * Component details sets.
 */
export const ComponentDetailsSets = (props: ComponentDetailsProps): JSX.Element => {
  const { t } = useTranslation();
  const { componentDetails } = props;

  const labels = {
    includedInSets: t(COMPONENT_SERVICE_STRINGS.includedInSets),
    noAvailableSets: t(COMPONENT_SERVICE_STRINGS.noAvailableSets),
    viewSet: t(COMPONENT_SERVICE_STRINGS.viewInSet),
  };

  const componentSets = componentDetails.sets.map((set: EntityComponentVersionSetsItem, index: number) => {
    return <ComponentDetailsSetsItem key={index} set={set} />;
  });

  return (
    <div className="component-details__sets">
      <h2>{labels.includedInSets}</h2>
      <div className="component-details__sets-list-container">
        {componentSets.length ? (
          <ul className="component-details__sets-list">{componentSets}</ul>
        ) : (
          <EmptyState caption={labels.noAvailableSets} classes="component-details__sets-list-empty" />
        )}
      </div>
    </div>
  );
};
